import HandleLettersDetails from './HandleLettersDetails.jsx';

export {
  HandleLettersDetails
};


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/detail-handle-letters/index.js